import { useCallback } from 'react';
import { CanvasElementType, CanvasStickyNote } from '../canvas-types';
import { RfNodeStickyNote } from '../canvas-types/nodeTypesData';

const emptyStickyNotesNodes: RfNodeStickyNote[] = [];

export const useStickyNotesNodesFactory = () => {
  const createFlowNodesFromSweepStickyNotesNodes = useCallback(
    ({ stickyNotesNodes }: { stickyNotesNodes?: CanvasStickyNote[] }): RfNodeStickyNote[] => {
      if (!stickyNotesNodes) {
        return emptyStickyNotesNodes;
      }
      const nodes: RfNodeStickyNote[] = [];

      stickyNotesNodes?.forEach((stickyNote) => {
        nodes.push({
          id: stickyNote.id,
          type: CanvasElementType.STICKY_NOTE,
          data: {
            color: stickyNote.color,
            richText: stickyNote.richText,
          },
          position: stickyNote.xyPosition,
          width: stickyNote.width,
          height: stickyNote.height,
          dragHandle: '.drag-handle',
          parentId: stickyNote.sectionId,
        });
      });

      return nodes;
    },
    [],
  );

  return {
    createFlowNodesFromSweepStickyNotesNodes,
  };
};

export default useStickyNotesNodesFactory;
